// (c) chaehongee. Confidential and proprietary.

import { useTranslation } from 'react-i18next'
import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme, type Theme } from '../../hooks/useTheme'
import styles from './ThemeSwitcher.module.css'

const THEME_OPTIONS: { value: Theme; labelKey: string; Icon: typeof Sun }[] = [
    { value: 'system', labelKey: 'themeSystem', Icon: Monitor },
    { value: 'light', labelKey: 'themeLight', Icon: Sun },
    { value: 'dark', labelKey: 'themeDark', Icon: Moon },
]

interface ThemeSwitcherProps {
    variant?: 'default' | 'compact'
}

export function ThemeSwitcher({ variant = 'default' }: ThemeSwitcherProps) {
    const { theme, setTheme } = useTheme()
    const { t } = useTranslation('dashboard')

    return (
        <div className={`${styles.root} ${variant === 'compact' ? styles.compact : ''}`}>
            {THEME_OPTIONS.map(({ value, labelKey, Icon }) => (
                <button
                    key={value}
                    type="button"
                    className={styles.themeButton}
                    data-active={theme === value}
                    onClick={() => setTheme(value)}
                    aria-label={t(labelKey)}
                >
                    <Icon className={styles.icon} />
                    {variant === 'default' && <span>{t(labelKey)}</span>}
                </button>
            ))}
        </div>
    )
}
